import React from 'react';

import { Grid } from '@mui/material';
import ContactNote from 'types/ContactNote';
import { addDays } from 'date-fns';
import { ReactComponent as TimeIcon } from 'assets/icons/Time.svg';
import { formatDateTime, isEmpty } from 'utils/stringUtil';
import { JBSection, JBTitleValueGrid } from '@juliusbaer-gcrm/gcrm-frontend-components';
import { ContactNoteStatus } from 'views/ContactNoteForm/data/statusOptions';

/**
 * The "ContactNote summary" section of the contactNote details view
 * @param props.contactNote The contactNote to show the details of.
 */
const ContactNoteDetailsEditHistory = (props: { contactNote: ContactNote }) => {
  const createdByFullName = `${props.contactNote.createdByFullName} (${props.contactNote.createdBy})`;
  const createdDate = new Date(props.contactNote.createdDateTime);

  const endDateTime = addDays(createdDate, 45);
  const endDayName = endDateTime.toLocaleDateString('en-GB', {
    weekday: 'long',
  });
  const endMonthName = endDateTime.toLocaleDateString('en-GB', {
    month: 'long',
  });
  const endMonthDay = endDateTime.toLocaleDateString('en-GB', {
    day: 'numeric',
  });
  const endYear = endDateTime.toLocaleDateString('en-GB', { year: 'numeric' });
  const differenceInTime = Math.round(endDateTime.getTime().valueOf() - Date.now().valueOf());
  const remainingDays = differenceInTime / (1000 * 3600 * 24);
  const dateObject = {
    endDate: '-',
  };
  dateObject.endDate = `${endDayName}, ${endMonthName} ${endMonthDay}, ${endYear}`;
  if (remainingDays > 0 && props.contactNote.status !== ContactNoteStatus.SUBMITTED) {
    if (remainingDays.toFixed(0) === '1') {
      dateObject.endDate = `${dateObject.endDate} (${remainingDays.toFixed(0)} day left)`;
    } else {
      dateObject.endDate = `${dateObject.endDate} (${remainingDays.toFixed(0)} days left)`;
    }
  }

  function DetailDateFields() {
    if (props.contactNote.status === ContactNoteStatus.EDITABLE) {
      if (isEmpty(props.contactNote.tripId)) {
        return (
          <JBTitleValueGrid
            title="Editable until"
            value={props.contactNote.status === ContactNoteStatus.EDITABLE ? dateObject.endDate : '-'}
            gridSize={4}
          />
        );
      } else return <Grid item xs={4} />;
    } else {
      // if status is Submitted we show submittedDate regardless if tripId exists or not
      return (
        <JBTitleValueGrid title="Submitted" value={formatDateTime(props.contactNote.submittedDateTime)} gridSize={4} />
      );
    }
  }

  return (
    <JBSection title="Details & edit history" avatar={<TimeIcon fontSize="large" />}>
      <Grid container>
        <JBTitleValueGrid title="Created" value={formatDateTime(props.contactNote.createdDateTime)} gridSize={2} />
        <JBTitleValueGrid title="Created by" value={createdByFullName} gridSize={2} />
        <JBTitleValueGrid title="CLM contact note ID" value={props.contactNote.contactNoteId} gridSize={2} />
        <JBTitleValueGrid
          title="CRM contact note ID"
          value={isEmpty(props.contactNote.legacyId) ? '-' : props.contactNote.legacyId}
          gridSize={2}
        />
        {DetailDateFields()}
      </Grid>
    </JBSection>
  );
};

export default ContactNoteDetailsEditHistory;
